import { uniqBy } from 'lodash';
import {
  ArticlesQuery_,
  ArticleFieldsFragment_,
  TagFieldsFragment_,
  TagsWithArticlesQuery_,
  useArticlesQuery,
  useTagsWithArticlesQuery,
  useArticleBodySearchQuery,
  useArticleTitleSearchQuery,
  useTagGroupsQuery,
} from 'models';

export type ArticlesQuery = ArticlesQuery_;
export type Article = ArticleFieldsFragment_;

export type Tag = TagFieldsFragment_;

export type TagsWithArticles = TagsWithArticlesQuery_;

export function getArticles() {
  const { data } = useArticlesQuery();
  return data?.Article;
}

export function useArticles() {
  const { data, loading } = useArticlesQuery();

  const articles = data?.Article?.filter((article) => !article.isHidden) || [];
  return { articles, articlesAreLoading: loading };
}

export function useArticlesWithTags() {
  const { data, loading } = useTagsWithArticlesQuery();
  const result = data?.Tag ? data.Tag : [];
  return { tags: result, tagsAreLoading: loading };
}

export function useTagGroups() {
  const { data, loading } = useTagGroupsQuery();
  const result = data?.TagGroup ? data.TagGroup : [];
  return { tagGroups: result, tagGroupsAreLoading: loading };
}

export function useArticleSearch(query: string) {
  const bodySearch = useArticleBodySearchQuery({ variables: { q: `%${query}%` } });

  const bodySearchData = bodySearch.data && bodySearch.data.Article ? bodySearch.data.Article : [];

  const titleSearch = useArticleTitleSearchQuery({ variables: { q: `%${query}%` } });
  const isLoading = bodySearch.loading || titleSearch.loading;

  const titleSearchData =
    titleSearch.data && titleSearch.data.Article ? titleSearch.data.Article : [];

  const searchedArticles = uniqBy(bodySearchData.concat(titleSearchData), (item) => item.id);

  const filteredArticles = searchedArticles.filter((article) => {
    return !article.isHidden;
  });
  return {
    searched: filteredArticles,
    searchIsLoading: isLoading,
  };
}
